<template>
  <div>
    <div class="edit-editor">
      <div class="edit-editor-title">
        {{data.moduleName}}
      </div>
      <!-- 基本信息 -->

      <div class="edit-editor-content" v-show="data.moduleName === '基本信息'">
        <el-form ref="editModuleBasicInfo" :model="formData" :rules="rules">
          <div class="edit-module-item-name">求职意向</div>
          <el-form-item prop="username">
            <el-input
              v-model="formData.username"
              placeholder="求职意向"
              @input="val => change('formData', 'username', val)"/>
          </el-form-item>

          <div class="edit-editor-menu margin-top-24">
            <div class="edit-editor-item">
              <div class="edit-module-item-name">当前状态</div>
              <el-form-item prop="start_at">
                <el-input
                v-model="formData.username"
                placeholder="当前状态"
                @input="val => change('formData', 'username', val)"/>
              </el-form-item>
            </div>
            <div class="edit-editor-item">
              <div class="edit-module-item-name">期望城市</div>
              <el-form-item prop="end_at">
                <el-input
                  v-model="formData.username"
                  placeholder="期望城市"
                  @input="val => change('formData', 'username', val)"/>
              </el-form-item>
            </div>
          </div>

          <div class="edit-module-item-name margin-top-24">期望薪资</div>
          <div class="edit-editor-menu">
            <div class="edit-editor-item">
              <el-form-item prop="start_at">
                <el-input
                v-model="formData.username"
                placeholder="1k"
                @input="val => change('formData', 'username', val)"/>
              </el-form-item>
            </div>
            <div class="edit-editor-item">
              <el-form-item prop="end_at">
                <el-input
                  v-model="formData.username"
                  placeholder="2k"
                  @input="val => change('formData', 'username', val)"/>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>

      <div class="edit-editor-btn">
        <button @click="close">取消</button>
        <button class="active" @click="save">保存</button>
      </div>
    </div>
  </div>
</template>
<script>
// 求职意向 - 请填写意向岗位
// 当前工作状态 - 请选择
// 期望薪资 - 如：5-8k
// 期望城市 - 请选择
import { mapState } from 'vuex';
import api from '@/api';
import {dealSignatrue} from '@/assets/js/util';
import richText from '@/components/base/richText';
import rules from '@/assets/json/rules';
const placeholder = {
  'homepage': '个人网站',
  'wechat': '微信',
  'linked_in': 'linkedin',
  'height': '身高cm',
  'weight': '体重kg',
  'ethnic': '民族',
  'hometown': '籍贯',
  'political_status': '政治面貌',
  'marriage': '婚姻状况',
  'gender': '性别',
  'birthday': '生日'
};
const infoMenu = [
  [
    {
      key: 'homepage',
      placeholder: placeholder.homepage
    },
    {
      key: 'wechat',
      placeholder: placeholder.wechat
    },
    {
      key: 'linked_in',
      placeholder: placeholder.linked_in
    }
  ],
  [
    {
      key: 'birthday',
      placeholder: placeholder.birthday
    },
    {
      key: 'gender',
      placeholder: placeholder.gender
    },
    {
      key: 'height',
      placeholder: placeholder.height
    },
    {
      key: 'weight',
      placeholder: placeholder.weight
    },
    {
      key: 'ethnic',
      placeholder: placeholder.ethnic
    },
    {
      key: 'hometown',
      placeholder: placeholder.hometown
    },
    {
      key: 'political_status',
      placeholder: placeholder.political_status
    },
    {
      key: 'marriage',
      placeholder: placeholder.marriage
    }
  ]
];
export default {
  name: 'editModelBasicInfo',
  components: {
    richText
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('cvs', ['cv', 'editorCvToken'])
  },
  data() {
    // 验证规则
    const phone = (rule, value, callback) => {
      if (!value)
        return callback(new Error('电话号不能为空'));
      if (/^1[3-9]\d{9}$/.test(value))
        return callback(new Error('电话号格式不正确'));
    }
    return {
      oldFormData: {},
      // 表单数据-必传数据
      formData: {
        username: '',
        phone: '',
        email: '',
        address: ''
      },
      infoMenu: JSON.parse(JSON.stringify(infoMenu)),
      // 手动添加的模块, 数据来源infomenu
      infoModule: [],
      // 验证规则
      rules: {
        username: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        address: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    'cv.profile': {
      keep: true,
      immediate: true,
      handler: function (profile) {
        // 设置form数据
        this.formData = {
          username: profile.username || '',
          phone: profile.phone || '',
          email: profile.email || '',
          address: profile.address || ''
        };
        // 设置添加模块的数据
        if (profile['homepage']) {
          this.infoModule.push({
            key: 'homepage',
            value: profile['homepage'],
            placeholder: placeholder['homepage']
          })
        }
        if (profile['wechat']) {
          this.infoModule.push({
            key: 'wechat',
            value: profile['wechat'],
            placeholder: placeholder['wechat']
          })
        }
        if (profile['linked_in']) {
          this.infoModule.push({
            key: 'linked_in',
            value: profile['linked_in'],
            placeholder: placeholder['linked_in']
          })
        }
        if (profile['height']) {
          this.infoModule.push({
            key: 'height',
            value: profile['height'],
            placeholder: placeholder['height']
          })
        }
        if (profile['weight']) {
          this.infoModule.push({
            key: 'weight',
            value: profile['weight'],
            placeholder: placeholder['weight']
          })
        }
        if (profile['ethnic']) {
          this.infoModule.push({
            key: 'ethnic',
            value: profile['ethnic'],
            placeholder: placeholder['ethnic']
          })
        }
        if (profile['hometown']) {
          this.infoModule.push({
            key: 'hometown',
            value: profile['hometown'],
            placeholder: placeholder['hometown']
          })
        }
        if (profile['political_status']) {
          this.infoModule.push({
            key: 'political_status',
            value: profile['political_status'],
            placeholder: placeholder['political_status']
          })
        }
        if (profile['marriage']) {
          this.infoModule.push({
            key: 'marriage',
            value: profile['marriage'],
            placeholder: placeholder['marriage']
          })
        }
        if (profile['gender']) {
          this.infoModule.push({
            key: 'gender',
            value: profile['gender'],
            placeholder: placeholder['gender']
          })
        }
        if (profile['birthday']) {
          this.infoModule.push({
            key: 'birthday',
            value: profile['birthday'],
            placeholder: placeholder['birthday']
          })
        }
        // 删除已有模块的添加按钮

        let infoModule = this.infoModule;
        let infoMenu = this.infoMenu;
        // debugger
        for (let i = 0; i < infoMenu.length; i++) {
          for (let j = infoMenu[i].length - 1; j >= 0; j--) {
            for (let k = 0; k < infoModule.length; k++) {
              if (infoMenu[i][j].key === infoModule[k].key) {
                infoMenu[i].splice(j, 1);
                break;
              }
            }
          }
        }
        this.infoMenu = infoMenu;
      }
    }
  },
  methods: {
    getRulesTitle(title, check) {
      for (let i = 0; i < rules.rules.length; i++) {
        if (rules.rules[i].name === title || (check && check.name === rules.rules[i].name)) {
          return rules.rules[i].title;
        }
      }
      return '提示';
    },
    back() {
      if (_.isEqual(this.oldFormData, this.formData)) {
        this.close();
        return false;
      }

      const alertData = {
        show: true,
        type: 'message',
        messageTitle: '温馨提示',
        showCancelButton: true, //取消按钮
        showConfirmButton: true, // 确定按钮
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        confirmButtonClass: 'cvs-edit-cancelButtonClass',
        cancelButtonClass: 'cvs-edit-confirmButtonClass',
        messageContent: `
          <p>还有内容尚未保存，确定离开吗？</p>
        `,
        confirm: async close => {
          this.close();
          close();
        },
        cancel: async close => {
          close();
        }
      };
      this.$store.dispatch('app/setAlertData', alertData);
    },
    close() {
      this.$emit('close');
    },
    // 添加信息模块
    addModule(data, index, num) {
      let infoModule = this.infoModule;
      let module = {
        ...data,
        value: ''
      };
      infoModule.push(module);
      this.infoModule = infoModule;
      // 删除添加模块
      let infoMenu = this.infoMenu;
      infoMenu[num].splice(index, 1);
      this.infoMenu = infoMenu;
    },
    /**
     * input or select value change event
     * @param {string} type 数据存放类型
     * @param {string} key 数据键
     * @param {any} value 数据value
     */
    change(type, key, value) {
      console.log(type, key, value);
      this.$store.commit('cvs/SET_CV_PROFILE_KEY_VALUE', {key, value});
    },
    save() {
      this.$refs['editModuleBasicInfo'].validate(async (valid) => {
        if (!valid) return false;
        let data = {
          cv_token: this.editorCvToken,
          username: this.formData.username,
          phone: this.formData.phone,
          address: this.formData.address,
          email: this.formData.email,
          hometown: this.cv.profile.hometown || '',
          marriage: this.cv.profile.marriage || '',
          gender: this.cv.profile.gender || '',
          current_job: this.cv.profile.current_job || '',
          exp_job: this.cv.profile.exp_job || '',
          city: this.cv.profile.city || '',
          political_status: this.cv.profile.political_status || '',
          height: this.cv.profile.height || '',
          weight: this.cv.profile.weight || '',
          expected_salary: this.cv.profile.expected_salary || '',
          ethnic: this.cv.profile.ethnic || '',
          homepage: this.cv.profile.homepage || '',
          linked_in: this.cv.profile.linked_in || '',
          wechat: this.cv.profile.wechat || '',
          birthday: this.cv.profile.birthday || ''
        };
        data = await dealSignatrue(data);
        let res = await api.cvs.createProfile(data);
        if (res.status === 1) {
          this.$message.success('保存成功');
          setTimeout(() => {
            this.$emit('close');
          }, 300);
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  },
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/cvsEditModule.scss';
.edit-editor {
  overflow: hidden;
  padding: 0 28px;
  position: relative;

  .name {
    font-size: 16px;
    color: #404040;
  }


  .add-module {
    display: flex;
    flex-wrap: wrap;
    .add-module-menu {
      height: 38px;
      line-height: 38px;
      padding: 0 24px;
      color: #606060;
      font-size: 14px;
      background: #F9F9F9;
      margin-right: 16px;
      margin-bottom: 16px;
      cursor: pointer;
      b {
        margin-right: 4px;
        font-size: 16px;
      }
    }
  }

}
</style>
